const defaultConsts = {
  userManagement: {
    defaultAdminUserName: 'admin',
  },
  localization: {
    defaultLocalizationSourceName: 'Vicutu',
  },
  authorization: {
    encrptedAuthTokenName: 'enc_auth_token',
  },
  appBaseUrl: 'http://localhost:8080',
  remoteServiceBaseUrl: 'http://192.168.1.43:6810',
  token_root: 'http://192.168.1.43:8086',
  response_type: 'id_token token',
  scope:
    'IdentityService VipService ProductService OrderService AlbumService MarketingService MallConfigService ArticleService DistributionService offline_access openid',
}

let env =
  process.env.NODE_ENV === 'development'
    ? 'development'
    : process.env.VUE_APP_TITLE === 'alpha'
    ? 'alpha'
    : 'production'
switch (env) {
  case 'development':
    // 测试站点
    defaultConsts.appBaseUrl = 'http://localhost:8080'
    defaultConsts.remoteServiceBaseUrl = 'https://chaomeihui.api.baiyunhl.top'
    defaultConsts.token_root = 'https://chaomeihui.auth.baiyunhl.top'
    break
  case 'production':
    // 正式站点
    defaultConsts.appBaseUrl = 'http://chaomeihui.admin.baiyunhl.top'
    defaultConsts.remoteServiceBaseUrl = 'https://chaomeihui.api.baiyunhl.top'
    defaultConsts.token_root = 'https://chaomeihui.auth.baiyunhl.top'
    break
  case 'alpha':
    // 测试站点
    defaultConsts.appBaseUrl = 'http://chaomeihui.admin.baiyunhl.top'
    defaultConsts.remoteServiceBaseUrl = 'https://chaomeihui.api.baiyunhl.top'
    defaultConsts.token_root = 'https://chaomeihui.auth.baiyunhl.top'

    break
}

export default defaultConsts
